import { c as _c } from "react/compiler-runtime";
import { Link } from '@repo/ui/Link';
import { renderStructuredContent } from '../../renderContext';
import type { StructuredContentDocumentWithRenderer } from '../../types';
export type AnchorLinkProps = StructuredContentDocumentWithRenderer<{
  target: string;
}>;
export const AnchorLink = t0 => {
  const $ = _c(7);
  const {
    props: t1
  } = t0;
  const {
    children,
    target
  } = t1;
  if (!children) {
    return null;
  }
  let t2;
  if ($[0] !== children || $[1] !== target) {
    let t3;
    if ($[3] !== target) {
      t3 = (child, idx) => <Link data-sc-link={true} key={idx} href={`#${target}`} underline="hover">{typeof child === "string" ? child : renderStructuredContent(child)}</Link>;
      $[3] = target;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = [children].flat().map(t3);
    $[0] = children;
    $[1] = target;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <>{t2}</>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};